import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateClientProfile } from './get-client-profile'

const activateClient = async (clientId: string) => {
  const response = await authAPI.put(`/client/${clientId}/activate`)
  return response.data
}

export const useActivateClient = (clientId: string) => {
  const invalidate = useInvalidateClientProfile(clientId)

  return useMutation({
    mutationFn: () => activateClient(clientId),
    onSuccess: invalidate,
  })
}
